var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthereumLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m9.994 14.976-.075.092v4.711l.075.221 6.143-8.651-6.143 3.627Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M10.002 20v-5.024l-6.14-3.627L10.003 20ZM9.994 0 9.86.456V13.68l.134.134 6.14-3.629L9.993 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m10.002 0-6.14 10.186 6.14 3.63V0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthereumLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethereum-light.b697fb248dd563e98c44f570126e5fec.svg";